import request from '@/utils/request'

export const getQuotes = params => request.get('/accounting/quotes', { params })

export const createQuote = data => request.post('/accounting/quotes', data)

export const getQuote = id => request.get(`/accounting/quotes/${id}`)

export const postQuote = id => request.post(`/accounting/quotes/${id}/post`)
